/* ==========================================================================
   Custom Mylar Bags configurator  |  Black Unicorn Hub
   Vanilla JS, no dependencies. Works on Debut (vintage) and OS 2.0 themes.

   HOW PRICING WORKS
   -----------------
   Every price is a real Shopify variant price. The page never computes one.

     Fixed tier   Quantity option is a number ("256"). Variant price is the
                  whole run. Cart quantity is 1.

     Custom       Quantity option is "Custom x32" or "Custom 512+ x32".
                  Variant price is ONE PACK. Cart quantity is the number of
                  packs. Pack size is read from the option value itself, so
                  there is no second source of truth to drift.

   WHY PACKS, NOT SINGLE BAGS
   --------------------------
   Selling custom quantities per bag meant a $1.00 variant existed on a public
   product feed. Shopify has no server-side minimum quantity below Plus, so a
   browser-side minimum is bypassed by posting straight to /cart/add. That is
   exactly what happened: three card-testing orders for one bag at $1.00, all
   with a landing page of /cart/add.js. Selling by the pack makes the minimum
   structural rather than advisory, so the cheapest line on the store is the
   price of a real minimum order.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-cmb-root]');
  if (!root) return;

  var dataEl = document.querySelector('[data-cmb-data]');
  if (!dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var variants = (DATA.variants || []).filter(function (v) { return v.available; });
  if (!variants.length) return;

  // "Custom x32"  ->  threshold 0,   pack 32
  // "Custom 512+ x32" -> threshold 512, pack 32
  var CUSTOM_RE = /^Custom(?:\s+(\d+)\s*\+)?\s*x\s*(\d+)$/i;
  var CUSTOM_TOKEN = '__custom__';   // internal UI value, never a Shopify option value
  var MAX_BAGS = 100000;

  // Flat artwork size per bag size, width x height in inches.
  // Keys must match the Size option values in the product exactly.
  var SIZE_SPECS = {
    '3.5g':    '4 x 5 inches',
    '7g':      '4.5 x 6.5 inches',
    '1 ounce': '5 x 7 inches',
    '1 pound': '16 x 13 inches'
  };

  var form       = root.querySelector('[data-cmb-form]');
  var idInput    = root.querySelector('[data-cmb-variant-id]');
  var qtyInput   = root.querySelector('[data-cmb-cart-qty]');
  var submitBtn  = root.querySelector('[data-cmb-submit]');
  var unitEl     = root.querySelector('[data-cmb-unit]');
  var totalEl    = root.querySelector('[data-cmb-total]');
  var noteEl     = root.querySelector('[data-cmb-note]');
  var errorEl    = root.querySelector('[data-cmb-error]');
  var fileInput  = root.querySelector('[data-cmb-file]');
  var fileName   = root.querySelector('[data-cmb-file-name]');
  var laterBox   = root.querySelector('[data-cmb-later]');
  var customWrap = root.querySelector('[data-cmb-custom-wrap]');
  var customQty  = root.querySelector('[data-cmb-custom-qty]');
  var customHint = root.querySelector('[data-cmb-custom-hint]');
  var qtyProp    = root.querySelector('[data-cmb-qty-prop]');
  var specEl     = root.querySelector('[data-cmb-artwork-spec]');
  var specProp   = root.querySelector('[data-cmb-spec-prop]');

  var groups = {
    size:     root.querySelector('[data-cmb-group="size"]'),
    quantity: root.querySelector('[data-cmb-group="quantity"]'),
    finish:   root.querySelector('[data-cmb-group="finish"]')
  };

  var state = { size: null, quantity: null, finish: null };

  /* ---------------------------------------------------------------- utils */

  function formatMoney(cents) {
    var fmt = DATA.moneyFormat || '${{amount}}';
    var value = cents / 100;

    function withCommas(num, decimals) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount':             return withCommas(value, 2);
        case 'amount_no_decimals': return withCommas(value, 0);
        case 'amount_with_comma_separator':
          return withCommas(value, 2).replace(/,/g, '~').replace(/\./g, ',').replace(/~/g, '.');
        case 'amount_no_decimals_with_comma_separator':
          return withCommas(value, 0).replace(/,/g, '.');
        default:                   return withCommas(value, 2);
      }
    });
  }

  function num(n) { return Number(n).toLocaleString(); }

  function parseCustom(value) {
    var m = CUSTOM_RE.exec(value);
    if (!m) return null;
    return { threshold: m[1] ? parseInt(m[1], 10) : 0, pack: parseInt(m[2], 10) };
  }

  function isCustomOption(value) { return CUSTOM_RE.test(value); }

  function uniqueBy(list, key) {
    var seen = Object.create(null), out = [];
    list.forEach(function (item) {
      var v = item[key];
      if (v == null || seen[v]) return;
      seen[v] = true;
      out.push(v);
    });
    return out;
  }

  function matching(filters) {
    return variants.filter(function (v) {
      return Object.keys(filters).every(function (k) {
        return filters[k] == null || v[k] === filters[k];
      });
    });
  }

  function tiersFor(size) {
    return uniqueBy(matching({ size: size }), 'quantity')
      .filter(function (q) { return /^\d+$/.test(q); })
      .sort(function (a, b) { return Number(a) - Number(b); });
  }

  function customVariants(size, finish) {
    return matching({ size: size, finish: finish })
      .filter(function (v) { return isCustomOption(v.quantity); });
  }

  // Pack size is the minimum order quantity. It comes from the option value,
  // so changing it means changing the CSV, not this file.
  function packFor(size) {
    var any = matching({ size: size }).filter(function (v) { return isCustomOption(v.quantity); })[0];
    return any ? parseCustom(any.quantity).pack : 0;
  }

  /* ------------------------------------------------------------- rendering */

  function renderGroup(name, entries, selected) {
    var container = groups[name];
    if (!container) return;
    container.innerHTML = '';

    entries.forEach(function (entry) {
      var label = document.createElement('label');
      label.className = 'cmb__option' + (entry.enabled ? '' : ' is-disabled');

      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'cmb-' + name;
      input.value = entry.value;
      input.checked = (entry.value === selected);
      input.disabled = !entry.enabled;

      var span = document.createElement('span');
      span.className = 'cmb__option-text';
      span.innerHTML = entry.label;

      input.addEventListener('change', function () {
        state[name] = entry.value;
        if (name === 'size') { state.quantity = null; state.finish = null; }
        render();
        if (name === 'quantity' && entry.value === CUSTOM_TOKEN && customQty) {
          customQty.focus();
        }
      });

      label.appendChild(input);
      label.appendChild(span);
      container.appendChild(label);
    });
  }

  function render() {
    // ---- Size
    var sizes = uniqueBy(variants, 'size');
    if (sizes.indexOf(state.size) === -1) state.size = sizes[0];
    renderGroup('size', sizes.map(function (s) {
      return { value: s, label: s, enabled: true };
    }), state.size);


    // ---- Artwork size for the chosen bag, shown next to the upload
    var spec = SIZE_SPECS[state.size];
    if (specEl) {
      if (spec) {
        specEl.innerHTML = 'Artwork size for the ' + state.size +
          ' bag: <strong>' + spec + '</strong> flat, plus 3mm bleed on every edge.';
        specEl.hidden = false;
      } else {
        specEl.hidden = true;
      }
    }
    // carry it onto the order so production never has to look it up
    if (specProp) specProp.value = spec ? state.size + ' / ' + spec : '';

    // ---- Quantity
    var tiers = tiersFor(state.size);
    var pack = packFor(state.size);

    var qtyEntries = tiers.map(function (q) {
      return { value: q, label: q + '<small>bags</small>', enabled: true };
    });
    if (pack) {
      qtyEntries.push({ value: CUSTOM_TOKEN, label: 'Custom<small>quantity</small>', enabled: true });
    }

    if (!qtyEntries.some(function (e) { return e.value === state.quantity; })) {
      state.quantity = qtyEntries[0].value;
    }
    renderGroup('quantity', qtyEntries, state.quantity);

    // ---- Custom quantity input
    var usingCustom = (state.quantity === CUSTOM_TOKEN);
    if (customWrap) customWrap.hidden = !usingCustom;
    if (usingCustom && customQty) {
      customQty.min = pack;
      customQty.step = pack;
      customQty.max = MAX_BAGS;
      customQty.placeholder = 'e.g. ' + (tiers[0] || pack * 4);
      if (customHint) {
        customHint.textContent = 'Sold in packs of ' + num(pack) + '. Minimum ' + num(pack) +
          ' bags. Anything in between is rounded up to the next full pack.';
      }
    }

    // ---- Finish
    var allFinishes = uniqueBy(variants, 'finish');
    var pool = usingCustom
      ? matching({ size: state.size }).filter(function (v) { return isCustomOption(v.quantity); })
      : matching({ size: state.size, quantity: state.quantity });
    var okFinishes = uniqueBy(pool, 'finish');

    if (okFinishes.indexOf(state.finish) === -1) {
      state.finish = okFinishes.indexOf('Standard') !== -1 ? 'Standard' : okFinishes[0];
    }

    renderGroup('finish', allFinishes.map(function (f) {
      return { value: f, label: f, enabled: okFinishes.indexOf(f) !== -1 };
    }), state.finish);

    updatePrice();
  }

  /* ----------------------------------------------------------------- price */

  // Pick the band whose threshold the actual bag count reaches. Highest
  // threshold wins, which is not the same as the highest or lowest price.
  function bandFor(size, finish, bags) {
    var bands = customVariants(size, finish).sort(function (a, b) {
      return parseCustom(a.quantity).threshold - parseCustom(b.quantity).threshold;
    });
    var chosen = null;
    bands.forEach(function (v) {
      if (bags >= parseCustom(v.quantity).threshold) chosen = v;
    });
    return chosen;
  }

  function quoteCustom(size, finish, typedBags) {
    var pack = packFor(size);
    if (!pack) return null;
    var packs = Math.ceil(typedBags / pack);
    var bags = packs * pack;
    var variant = bandFor(size, finish, bags);
    if (!variant) return null;
    return {
      variant: variant,
      pack: pack,
      packs: packs,
      bags: bags,
      lineQty: packs,
      perBagCents: variant.price / pack,
      totalCents: variant.price * packs
    };
  }

  function resolve() {
    if (state.quantity === CUSTOM_TOKEN) {
      var typed = parseInt(customQty && customQty.value, 10);
      if (!typed || typed < 1) return null;
      return quoteCustom(state.size, state.finish, typed);
    }

    var variant = matching({
      size: state.size, quantity: state.quantity, finish: state.finish
    })[0];
    if (!variant) return null;

    var qty = parseInt(state.quantity, 10) || 1;
    return {
      variant: variant,
      pack: 1,
      packs: 1,
      bags: qty,
      lineQty: 1,
      perBagCents: variant.price / qty,
      totalCents: variant.price
    };
  }

  // The supplier's own pricing has a cliff: 480 bags of 3.5g costs more than
  // 512 does. Rather than let the customer fall into it, offer the better deal.
  function betterDeal(r) {
    if (state.quantity !== CUSTOM_TOKEN) return null;
    var bands = customVariants(state.size, state.finish);
    var best = null;
    bands.forEach(function (v) {
      var t = parseCustom(v.quantity).threshold;
      if (t <= r.bags) return;
      var q = quoteCustom(state.size, state.finish, t);
      if (q && q.totalCents < r.totalCents && (!best || q.totalCents < best.totalCents)) best = q;
    });
    return best;
  }

  function blankPrice(message) {
    idInput.value = '';
    if (qtyInput) qtyInput.value = '1';
    unitEl.innerHTML = '&mdash;';
    totalEl.innerHTML = '&mdash;';
    noteEl.textContent = message || '';
    submitBtn.disabled = true;
  }

  function updatePrice() {
    if (state.quantity === CUSTOM_TOKEN) {
      var pack = packFor(state.size);
      var raw = (customQty && customQty.value || '').trim();
      if (!raw) { blankPrice('Enter how many bags you need.'); return; }
      var n = parseInt(raw, 10);
      if (!n || n < 1) { blankPrice('Enter a whole number of bags.'); return; }
      if (n < pack) {
        blankPrice('Minimum order for this size is ' + num(pack) + ' bags.');
        return;
      }
      if (n > MAX_BAGS) {
        blankPrice('For runs over ' + num(MAX_BAGS) + ' bags, contact us for a direct quote.');
        return;
      }
    }

    var r = resolve();
    if (!r) {
      blankPrice('That combination is not available. Try another finish.');
      return;
    }

    idInput.value = r.variant.id;
    if (qtyInput) qtyInput.value = String(r.lineQty);
    if (qtyProp) qtyProp.value = num(r.bags) + ' bags';

    unitEl.textContent = formatMoney(r.perBagCents);
    totalEl.textContent = formatMoney(r.totalCents);
    submitBtn.disabled = false;

    // Note line. Rounding and the better deal are NOT exclusive: a typed 440
    // rounds up to 448 AND has a cheaper option at 512, and the customer needs
    // to be told both. Showing only the rounding message hid the saving on
    // every typed value that was not already a whole pack.
    var typed = parseInt(customQty && customQty.value, 10);
    var deal = betterDeal(r);

    noteEl.classList.remove('cmb__summary-note--deal');

    if (deal) {
      var saving = formatMoney(r.totalCents - deal.totalCents);
      var rounded = (state.quantity === CUSTOM_TOKEN && typed && r.bags !== typed)
        ? 'Rounded up to ' + num(r.bags) + ' bags. '
        : '';
      noteEl.classList.add('cmb__summary-note--deal');
      noteEl.innerHTML = rounded +
        '<strong>Better deal:</strong> order ' +
        '<button type="button" class="cmb__dealbtn" data-cmb-apply-deal="' + deal.bags + '">' +
        num(deal.bags) + ' bags</button> and pay ' + saving + ' less than this.';
    } else if (state.quantity === CUSTOM_TOKEN && typed && r.bags !== typed) {
      noteEl.textContent = 'Rounded up to ' + num(r.bags) + ' bags, ' +
        num(r.packs) + ' packs of ' + num(r.pack) + '.';
    } else {
      var worst = 0;
      matching({ size: state.size, finish: state.finish }).forEach(function (v) {
        var c = parseCustom(v.quantity);
        var unit = c ? v.price / c.pack : v.price / (parseInt(v.quantity, 10) || 1);
        if (unit > worst) worst = unit;
      });
      if (worst > r.perBagCents) {
        noteEl.textContent = 'You save ' + formatMoney((worst - r.perBagCents) * r.bags) + ' at this quantity.';
      } else {
        noteEl.textContent = num(r.bags) + ' bags, printed to your artwork.';
      }
    }
  }

  // One click applies the suggested quantity.
  noteEl.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cmb-apply-deal]');
    if (!btn || !customQty) return;
    e.preventDefault();
    customQty.value = btn.getAttribute('data-cmb-apply-deal');
    updatePrice();
    customQty.focus();
  });

  if (customQty) {
    customQty.addEventListener('input', updatePrice);
    customQty.addEventListener('change', updatePrice);
    customQty.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
    });
  }

  /* ------------------------------------------------------------ file input */

  if (fileInput && fileName) {
    fileInput.addEventListener('change', function () {
      if (!fileInput.files.length) {
        fileName.textContent = 'No file chosen';
        return;
      }
      var file = fileInput.files[0];
      var mb = file.size / (1024 * 1024);
      if (mb > 20) {
        fileInput.value = '';
        fileName.textContent = 'No file chosen';
        showError('That file is ' + mb.toFixed(1) + ' MB. Shopify caps uploads at 20 MB. '
                + 'Send a smaller file, or tick "I will send my artwork later".');
        return;
      }
      clearError();
      fileName.textContent = file.name;
      if (laterBox) laterBox.checked = false;
    });
  }

  if (laterBox && fileInput) {
    laterBox.addEventListener('change', function () {
      if (laterBox.checked) {
        fileInput.value = '';
        if (fileName) fileName.textContent = 'No file chosen';
        clearError();
      }
    });
  }

  /* ------------------------------------------------------------ validation */

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function clearError() {
    if (!errorEl) return;
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  if (form) {
    // Debut's AJAX cart binds to forms posting to /cart/add. File uploads in
    // line item properties only survive a real form POST, so stop any other
    // submit handler from running. Capture phase, before theme JS sees it.
    form.addEventListener('submit', function (event) {
      var hasFile   = fileInput && fileInput.files && fileInput.files.length > 0;
      var sendLater = laterBox && laterBox.checked;

      if (!idInput.value) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showError(state.quantity === CUSTOM_TOKEN
          ? 'Enter a valid quantity before adding to cart.'
          : 'Pick a size, quantity and finish first.');
        return;
      }

      if (!hasFile && !sendLater) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showError('Upload your artwork, or tick "I will send my artwork later".');
        if (fileInput) fileInput.focus();
        return;
      }

      clearError();
      event.stopImmediatePropagation(); // let the native POST through, block AJAX
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding to cart...';
    }, true);
  }

  /* --------------------------------------------------------------- gallery */

  var hero = root.querySelector('.cmb__hero');
  Array.prototype.forEach.call(root.querySelectorAll('[data-cmb-thumb]'), function (thumb) {
    thumb.addEventListener('click', function () {
      if (!hero) return;
      hero.removeAttribute('srcset');
      hero.src = thumb.getAttribute('data-full');
    });
  });

  /* ------------------------------------------------------------------ boot */

  render();
})();